export default __webpack_public_path__ + "static/media/pic1.3bac4ee9.jpg";